import { render, staticRenderFns } from "./entregaArquivos.vue?vue&type=template&id=15f57406&scoped=true"
import script from "./entregaArquivos.vue?vue&type=script&lang=js"
export * from "./entregaArquivos.vue?vue&type=script&lang=js"
import style0 from "./entregaArquivos.vue?vue&type=style&index=0&id=15f57406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f57406",
  null
  
)

export default component.exports